import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { Box, Stack, Drawer, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
// hooks
import useNav from '../../../hooks/useNav';
import useResponsive from '../../../hooks/useResponsive';
// config
import { NAV } from '../../../config-global';
// components
import Scrollbar from '../../../components/scrollbar';
import { NavSectionVertical } from '../../../components/nav-section';
//
// import navConfig from './config-navigation';
import NavAccount from './NavAccount';
import NavToggleButton from './NavToggleButton';

// ----------------------------------------------------------------------

NavVertical.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function NavVertical({ openNav, onCloseNav }) {
  const { pathname } = useLocation();

  const isDesktop = useResponsive('up', 'lg');

  const [menu] = useNav();
  
  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Stack
        spacing={2}
        sx={{
          pt: 2.5,
          pb: 1.5,
          px: 2,
          flexShrink: 0,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.25,
            px: 1,
          }}
        >
          <Box
            sx={{
              width: 40,
              height: 40,
              display: 'grid',
              placeItems: 'center',
              borderRadius: '14px',
              color: '#8A5A00',
              bgcolor: '#FFF3D6',
              border: '1px solid #F8D48A',
              fontSize: 18,
              fontWeight: 800,
              boxShadow: '0 8px 18px rgba(245, 174, 47, 0.14)',
            }}
          >
            گ
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="subtitle1" sx={{ color: '#FFFFFF', fontWeight: 800 }} noWrap>
              هگزا
            </Typography>
            <Typography variant="caption" sx={{ color: alpha('#FFFFFF', 0.64) }} noWrap>
              سامانه مدیریت هوشمند
            </Typography>
          </Box>
        </Box>

        <NavAccount />
      </Stack>

      {/* <NavSectionVertical data={navConfig} /> */}
      
      <NavSectionVertical data={menu} />

      <Box sx={{ flexGrow: 1 }} />

      {/* <NavDocs /> */}
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD },
      }}
    >
      <NavToggleButton />

      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              zIndex: 0,
              width: NAV.W_DASHBOARD,
              color: '#FFFFFF',
              bgcolor: '#0E4565',
              backgroundImage: `radial-gradient(circle at 85% 8%, ${alpha('#3AA7D2', 0.2)} 0%, transparent 30%), linear-gradient(165deg, #145A7D 0%, #0E496A 48%, #0A3B59 100%)`,
              borderRight: `1px solid ${alpha('#FFFFFF', 0.1)}`,
              boxShadow: '10px 0 36px rgba(7, 42, 63, 0.24)',
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: {
              width: NAV.W_DASHBOARD,
              color: '#FFFFFF',
              bgcolor: '#0E4565',
              backgroundImage: `radial-gradient(circle at 85% 8%, ${alpha('#3AA7D2', 0.2)} 0%, transparent 30%), linear-gradient(165deg, #145A7D 0%, #0E496A 48%, #0A3B59 100%)`,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
